import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FONT_SANS } from '../constants';
import { colors } from '../theme/colors';
import { useLanguage } from '../context/LanguageContext';
import Progress from './Progress';

const Block = styled.div`
  width: min(480px, 100%);
  text-align: center;
`;

const Subtitle = styled.p`
  font-family: ${FONT_SANS};
  font-size: ${({ $compact }) => ($compact ? '13px' : '14px')};
  margin: ${({ $compact }) => ($compact ? '12px 0 0' : '1.5rem 0 1rem')};
  color: ${colors.inkMuted};
`;

const Stores = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
`;

const StoreBadge = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 12px;
  padding: 0 16px;
  height: 52px;
  border: 1px solid ${colors.secondaryBorder};
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(44, 42, 41, 0.08);
  }

  img {
    height: 28px;
    width: auto;
  }
`;

function DownloadSection({ compact = false }) {
  const { t } = useLanguage();

  return (
    <Block>
      {!compact && <Progress target={88} />}
      <Subtitle $compact={compact}>{t.download.subtitle}</Subtitle>
      {!compact && (
        <Stores>
          <StoreBadge to="/support" aria-label={t.download.iosLabel}>
            <img src={`${process.env.PUBLIC_URL}/img/iosbg.svg`} alt="" />
          </StoreBadge>
          <StoreBadge to="/support" aria-label={t.download.androidLabel}>
            <img src={`${process.env.PUBLIC_URL}/img/googlePlay.svg`} alt="" />
          </StoreBadge>
        </Stores>
      )}
    </Block>
  );
}

export default DownloadSection;
